<template>
  <div class="u-reg-line">
    <div class="cut-off"></div>
  </div>
</template>
<script>
export default {
  name: "sk-line"
};
</script>
<style lang=""></style>
